import ABCyaPhaser from "@abcya/abcya_phaser";
import FontKeys from "../FontKeys";
import gameData from "../gameData";
import SoundAssetKeys from "../SoundAssetKeys";

export default class Dot extends Phaser.GameObjects.Container {
  constructor(scene, parentRef, myNum, myColor, spritename, fontSize, fontColor, countby) {
    super(scene);

    this.parentRef = parentRef;
    if (!spritename) spritename = "Dot";
    this.bg = ABCyaPhaser.Images.addImage(0, 0, spritename, this);
    if (myColor) {
      this.bg.setTint(myColor.color);
    }

    if (!fontSize) fontSize = 24;
    if (!fontColor) fontColor = 0x727272;
    if (!countby) countby = 1;

    let displayNum = myNum * countby;
    this.displayNum = displayNum;

    if (gameData.isAlphabet) {
      let letters = "abcdefghijklmnopqrstuvwxyz";
      if (gameData.isUppercase) {
        displayNum = letters.charAt(this.displayNum - 1).toUpperCase();
      } else {
        displayNum = letters.charAt(this.displayNum - 1).toLowerCase();
      }
      this.displayNum = displayNum;
      if (displayNum === "j") {
        this.thej = ABCyaPhaser.Images.addImage(this.bg.width / 2, this.bg.height / 2, "thej", this).setOrigin(0.5);
        displayNum = " ";
      }
    }

    if (displayNum > 99) {
      fontSize -= 6;
    }
    if (displayNum < 0) {
      displayNum = " ";
    } else {
      displayNum = displayNum.toString();
    }

    this.lblNum = ABCyaPhaser.Text.addText(this.bg.width / 2, this.bg.height / 2, fontSize, fontColor, FontKeys._bpreplaybold, displayNum, this, true);
    ABCyaPhaser.Text.setFontStyle(this.lblNum, true);

    // the original code moved the registration point of this container, which isn't possible in Phaser, instead we move all the child objects to adjust for the change
    let bounds = this.getBounds();
    this.iterate(c => {
      c.x -= bounds.width / 2;
      c.y -= bounds.height / 2;
    });

    ABCyaPhaser.Container.setContainerInteractive(this);
  }

  pulseIn(waiter) {
    this.alpha = 0;
    this.scale = 1.4;
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, waiter, { scale: 1.4 }, Phaser.Math.Easing.Linear, () => this.popIn());
  }

  popIn() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop_01b, this.scene);

    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 240, { alpha: 1.0, scale: 1.6 }, Phaser.Math.Easing.Quadratic.In, () => this.unpulse());
  }

  pulse() {
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 120, { scale: 1.4 }, Phaser.Math.Easing.Quadratic.In, () => this.unpulse());
  }

  unpulse() {
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 120, { scale: 1 }, Phaser.Math.Easing.Quadratic.Out);
  }

  fadeAway() {
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 220, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => this.destroyDot());
  }

  destroyDot() {
    this.parentRef.killDot(this);
  }
}